import { groupBy } from '@wwe-portal/ui/lib/group-by';

import { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';

export const maxItemsByType: Record<OfferCardTypeEnum, 1 | 2 | 3> = {
  [OfferCardTypeEnum.SINGLE3]: 3,
  [OfferCardTypeEnum.SINGLE2]: 2,
  [OfferCardTypeEnum.SINGLE1]: 1,
} as const;

export const groupOfferByType = <
  T extends {
    type: OfferCardTypeEnum;
  },
>(
  offers: T[]
) =>
  groupBy(
    offers,
    (offer) => offer.type,
    (type) => maxItemsByType[type]
  );
